function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb82a"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb82a"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $a76d384475bbbf5d$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"dRVuC":"menu.734e60fc.js","9Ennv":"trophy1.41df93d1.png","1eF78":"trophy2.9e1ae678.png","2xSe0":"trophy3.93f2c632.png","QeKFN":"trophy4.f089d188.png"}'));

/* Sound toggle */ var $29cb7b5be2929e95$exports = {};

$29cb7b5be2929e95$exports = new URL((parcelRequire("27Lyk")).resolve("9Ennv"), import.meta.url).toString();


var $e4d5513f52fa7895$exports = {};

$e4d5513f52fa7895$exports = new URL((parcelRequire("27Lyk")).resolve("1eF78"), import.meta.url).toString();


var $6e94fff4ddf21016$exports = {};

$6e94fff4ddf21016$exports = new URL((parcelRequire("27Lyk")).resolve("2xSe0"), import.meta.url).toString();


var $21b8090cea05805f$exports = {};

$21b8090cea05805f$exports = new URL((parcelRequire("27Lyk")).resolve("QeKFN"), import.meta.url).toString();


function $b4e1a3265f56b2a8$export$eab19c48dcb6310d(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $b4e1a3265f56b2a8$export$911e03787a71545b(milliseconds) {
    return new Promise((resolve)=>{
        setTimeout(resolve, milliseconds);
    });
}
function $b4e1a3265f56b2a8$export$e68c847c0bceb7d5(key) {
    const storedData = localStorage.getItem(key);
    if (!storedData) {
        localStorage.setItem("levels", JSON.stringify([]));
        return [];
    }
    if (storedData) return JSON.parse(storedData);
    return null;
}


const $1011cc0b57ebed9a$var$soundOnButton = document.getElementById("sound-on");
const $1011cc0b57ebed9a$var$soundOffButton = document.getElementById("sound-off");
const $1011cc0b57ebed9a$var$backgroundMusic = document.getElementById("backgroundMusic");
/* Modals Constants */ const $1011cc0b57ebed9a$var$rulesModal = document.querySelector("#rules-modal");
const $1011cc0b57ebed9a$var$aboutUsModal = document.querySelector("#about-us-modal");
const $1011cc0b57ebed9a$var$trophiesModal = document.querySelector("#trophies-modal");
const $1011cc0b57ebed9a$var$levelsModal = document.querySelector("#levels-modal");
/* Open Modal Buttons */ const $1011cc0b57ebed9a$var$rulesButton = document.querySelector(".rules-button");
const $1011cc0b57ebed9a$var$aboutUsButton = document.querySelector(".about-us-button");
const $1011cc0b57ebed9a$var$trophiesButton = document.querySelector(".trophies-button");
const $1011cc0b57ebed9a$var$levelsButton = document.querySelector(".levels-button");
const $1011cc0b57ebed9a$var$level1Btn = document.getElementById("level1");
const $1011cc0b57ebed9a$var$level2Btn = document.getElementById("level2");
const $1011cc0b57ebed9a$var$level3Btn = document.getElementById("level3");
const $1011cc0b57ebed9a$var$level4Btn = document.getElementById("level4");
document.addEventListener("DOMContentLoaded", ()=>{
    const levels = (0, $b4e1a3265f56b2a8$export$e68c847c0bceb7d5)("levels");
    $1011cc0b57ebed9a$var$undisableLevels(levels);
});
$1011cc0b57ebed9a$var$soundOffButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$soundOffButton.classList.add("hide");
    $1011cc0b57ebed9a$var$soundOnButton.classList.remove("hide");
    $1011cc0b57ebed9a$var$backgroundMusic.play();
});
$1011cc0b57ebed9a$var$soundOnButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$soundOnButton.classList.add("hide");
    $1011cc0b57ebed9a$var$soundOffButton.classList.remove("hide");
    $1011cc0b57ebed9a$var$backgroundMusic.pause();
});
/* Close Modal Buttons */ const $1011cc0b57ebed9a$var$closeRulesButton = document.querySelector("#close-rules-modal-button");
const $1011cc0b57ebed9a$var$closeAboutUsButton = document.querySelector("#close-about-us-modal-button");
const $1011cc0b57ebed9a$var$closeTrophiesButton = document.querySelector("#close-trophies-modal-button");
const $1011cc0b57ebed9a$var$closeLevelsButton = document.querySelector("#close-levels-button");
/* Open rules modal */ $1011cc0b57ebed9a$var$rulesButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$rulesModal.classList.remove("hide-modal");
});
/* Close rules modal*/ $1011cc0b57ebed9a$var$closeRulesButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$rulesModal.classList.add("hide-modal");
});
/* Open About Us Modal */ $1011cc0b57ebed9a$var$aboutUsButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$aboutUsModal.classList.remove("hide-modal");
});
/* Close About Us Modal */ $1011cc0b57ebed9a$var$closeAboutUsButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$aboutUsModal.classList.add("hide-modal");
});
/* Open Trophies Modal */ $1011cc0b57ebed9a$var$trophiesButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$trophiesModal.classList.remove("hide-modal");
});
/* Close Trophies Modal */ $1011cc0b57ebed9a$var$closeTrophiesButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$trophiesModal.classList.add("hide-modal");
});
/* Open Levels Modal */ $1011cc0b57ebed9a$var$levelsButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$levelsModal.classList.remove("hide-modal");
});
/* Close Levels Modal */ $1011cc0b57ebed9a$var$closeLevelsButton.addEventListener("click", ()=>{
    $1011cc0b57ebed9a$var$levelsModal.classList.add("hide-modal");
});
$1011cc0b57ebed9a$var$level1Btn.addEventListener("click", ()=>{
    window.location.href = "src/levels/game.html";
});
$1011cc0b57ebed9a$var$level2Btn.addEventListener("click", ()=>{
    window.location.href = "src/levels/game2.html";
});
$1011cc0b57ebed9a$var$level3Btn.addEventListener("click", ()=>{
    window.location.href = "src/levels/game3.html";
});
$1011cc0b57ebed9a$var$level4Btn.addEventListener("click", ()=>{
    window.location.href = "src/levels/game4.html";
});
function $1011cc0b57ebed9a$var$undisableLevels(levels) {
    if (levels.includes(1)) {
        const html = `<img id="mario-trophy" src=${(0, (/*@__PURE__*/$parcel$interopDefault($29cb7b5be2929e95$exports)))} alt="Mario trophy"><h3>Mario Matrix</h3>`;
        const element = document.getElementById("mario-trophy");
        element.innerHTML = html;
        $1011cc0b57ebed9a$var$level2Btn.disabled = false;
    }
    if (levels.includes(2)) {
        const html = `<img id="pikachu-trophy" src=${(0, (/*@__PURE__*/$parcel$interopDefault($e4d5513f52fa7895$exports)))} alt="Pikachu trophy"><h3>Pikachu Paradox</h3>`;
        const element = document.getElementById("pikachu-trophy");
        element.innerHTML = html;
        $1011cc0b57ebed9a$var$level3Btn.disabled = false;
    }
    if (levels.includes(3)) {
        const html = `<img id="pacman-trophy" src=${(0, (/*@__PURE__*/$parcel$interopDefault($6e94fff4ddf21016$exports)))} alt="Pacman trophy">
    <h3>Pacman Prowess</h3>`;
        const element = document.getElementById("pacman-trophy");
        element.innerHTML = html;
        $1011cc0b57ebed9a$var$level4Btn.disabled = false;
    }
    if (levels.includes(4)) {
        const html = `<img id="invaders-trophy" src=${(0, (/*@__PURE__*/$parcel$interopDefault($21b8090cea05805f$exports)))} alt="Invaders trophy">
    <h3>Invader Invasion</h3>`;
        const element = document.getElementById("invaders-trophy");
        element.innerHTML = html;
    }
}


//# sourceMappingURL=menu.734e60fc.js.map
